import {Button, TextInput} from '@/components/atoms'
import {MaxDiscountModal} from '@/components/organisms'
import {defaultConditon, usePromotion} from '@/context/Promotion/PromotionContext'
import {PromotionType} from '@/types/promotion'
import {createPromotionConditions} from '@/utils/promotions/promotions'
import {ProductCombination} from '../components/ProductCombination'
import PromotionsConditions from '../components/PromotionsConditions'
import {ExcludeProducts} from '../components/PromotionsConditions/ExcludeProducts'
import SegmentSection from '../components/SegmentSection'

const PromotionsSetup = () => {
  const {
    promotionType,
    promotion: finalResult,
    onResultChange,
    maxDiscountModalVisible,
    setMaxDiscountModalVisible,
    promotionConfig,
    handleUpdatePromotionConfig,
  } = usePromotion()

  const conditions = finalResult?.promotionConditions
  const handleCreateLayer = () => {
    // We need to add a new layer for BUY_MULTIPLE_PRODUCTS or BUY_SINGLE_PRODUCT
    const currentSequence = conditions?.length ? conditions[conditions.length - 1].sequence : 0
    const newConditionGroup =
      promotionType === PromotionType.BUY_MULTIPLE_PRODUCTS
        ? {
            sequence: currentSequence + 1,
            conditionGroup: {
              conditions: [defaultConditon, defaultConditon],
            },
          }
        : {
            sequence: currentSequence + 1,
            conditionGroup: {
              conditions: conditions?.[0]?.conditionGroup?.conditions?.[0]
                ? conditions[0].conditionGroup.conditions.map(({ quantity, ...rest }) => rest)
                : [defaultConditon],
            },
            rewards: conditions?.[0]?.rewards
              ? conditions[0].rewards.map((reward) => ({
                  type: reward.type,
                  discountType: reward.discountType,
                }))
              : [],
          }

    const promotionConditions = [...(finalResult?.promotionConditions || []), newConditionGroup]
    onResultChange({
      promotionConditions: promotionConditions,
    })
  }
  const handleResetConditions = () => {
    onResultChange({promotionConditions: createPromotionConditions(promotionType)})
  }

  const handleSaveMaxDiscountConfig = async (newDiscount: number) => {
    try {
      await handleUpdatePromotionConfig({maxDiscountPercentage: newDiscount})
    } catch (error) {
      console.error('Error updating max discount config:', error)
      throw error
    }
  }

  return (
    <div className="flex flex-col gap-6">
      {/* Name Promotion Section */}
      <div className="flex flex-col gap-6 rounded-lg bg-[#1D1D1D] p-6">
        <h3 className="text-lg font-semibold">Name Promotion</h3>
        <div className="w-[300px]">
          <TextInput
            label="Name*"
            onChange={(value: string) => onResultChange({name: value})}
            value={finalResult?.name || ''}
            placeholderText="Promotion Name"
            isDark={true}
          />
        </div>
      </div>
      {/* Promotion Conditions Section */}
      <div className="flex flex-col gap-6 rounded-lg bg-[#1D1D1D] p-6">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold">Promotion Conditions*</h3>
          <Button
            //@ts-expect-error type errorr
            uiSchema={{variant: 'secondary', title: 'Reset', isDark: true, size: 'small'}}
            handleButton={handleResetConditions}
          />
        </div>
        {Array.isArray(conditions) &&
          conditions.map((condition, index) => (
            <PromotionsConditions
              key={condition?.sequence ?? index}
              index={index}
              condition={condition}
              promotionType={promotionType}
            />
          ))}
        {[PromotionType.BUY_SINGLE_PRODUCT, PromotionType.BUY_MULTIPLE_PRODUCTS].includes(promotionType) && (
          <Button
            //@ts-expect-error type errorr
            uiSchema={{variant: 'tertiary', title: 'Add Layer', isDark: true, iconLeading: 'add_box', size: 'medium'}}
            handleButton={handleCreateLayer}
          />
        )}
        <ProductCombination />
        <ExcludeProducts key={JSON.stringify(finalResult.excludedItems)} />
        {/* TO BE PICKED UP LATER */}
        {/* Preview Section
        {conditions?.length > 0 && (
          <div className="flex items-center gap-2">
            <div>
              <span className="font-bold">Preview:</span>{' '}
              <span className="font-normal">{generatePreviewMessage(conditions)}</span>
            </div>
          </div>
        )} */}
      </div>
      {/* Segments Section */}
      <SegmentSection />

      <MaxDiscountModal
        maxDiscountValue={promotionConfig?.maxDiscountPercentage}
        showModal={maxDiscountModalVisible}
        onCloseModal={() => setMaxDiscountModalVisible(false)}
        onSaveDiscount={handleSaveMaxDiscountConfig}
      />
    </div>
  )
}

export default PromotionsSetup
